import { useLayoutEffect, useState } from 'react';

interface ElementSize {
  width: number;
  height: number;
}

export const useElementSize = (elementRef: React.RefObject<HTMLElement | null>): ElementSize => {
  const [size, setSize] = useState<ElementSize>({ width: 48, height: 48 });

  useLayoutEffect(() => {
    const updateSize = () => {
      if (elementRef.current) {
        const rect = elementRef.current.getBoundingClientRect();
        setSize({
          width: rect.width || 48,
          height: rect.height || 48,
        });
      }
    };

    updateSize();

    if (!elementRef.current) return;

    const resizeObserver = new ResizeObserver(updateSize);
    resizeObserver.observe(elementRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [elementRef]);

  return size;
};
